import React, { useEffect, useState } from 'react';

const UpdateBanner = ({ timeoutSeconds = 300, onManualRefresh }) => {
    const [secondsLeft, setSecondsLeft] = useState(timeoutSeconds);

    useEffect(() => {
        const interval = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 1) {
                    onManualRefresh?.();
                    window.location.href = window.location.href;
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (secs) => {
        const min = Math.floor(secs / 60);
        const sec = secs % 60;
        return `${min}:${sec.toString().padStart(2, '0')}`;
    };

    return (
        <div
            className="bg-yellow-100 text-yellow-800 text-sm font-medium px-4 py-2 rounded-full shadow-sm w-full max-w-xl text-center cursor-pointer mx-auto"
            onClick={onManualRefresh}
        >
            ⚠️ New updates found! Click here to reload. Reloading in ({formatTime(secondsLeft)})
        </div>
    );
};

export default UpdateBanner;
